import React, { Component } from "react";
import { connect } from "react-redux";
import { getWarehouses } from "../../reducer";
import { Form } from "semantic-ui-react";
import propTypes from "prop-types";
import { Translate } from "react-localize-redux";

class WarehouseSelect extends Component {

    prepareWarehouses() {
        if (this.props.warehouses === null || typeof this.props.warehouses === 'undefined') {
            return [];
        }
        const warehouses = this.props.warehouses.filter((warehouse) => warehouse.active === 1)
            .map((warehouse) => (
            {key: warehouse.id, value: warehouse.id, text: warehouse.name}
        ));

        if(this.props.additionalWarehouses !== null && typeof this.props.additionalWarehouses !== 'undefined'){
            this.props.additionalWarehouses.forEach((element)=>{
                warehouses.unshift(element);
            });

        }

        return warehouses;
    }

    render() {

        return (
            <Translate>
                {
                    ({translate}) =>
                        <Form.Select
                            search
                            selection
                            fluid
                            label={translate('clock.warehouse.label')}
                            options={this.prepareWarehouses()}
                            value={this.props.value}
                            onChange={(e, {value}) => {
                                this.props.onChange(value)
                            }}
                            required
                        />
                }
            </Translate>
        )
    }

}

WarehouseSelect.propTypes = {
    onChange: propTypes.func,
    value: propTypes.number,
    additionalWarehouses: propTypes.array,
};

const mapStateToProps = state => ({
    warehouses: getWarehouses(state),
});


// No need to connect()!
export default connect(
    mapStateToProps
)(WarehouseSelect)



// WEBPACK FOOTER //
// ./src/scenes/Clock/components/WarehouseSelect/index.js